import { render, staticRenderFns } from "./SimpleTree.vue?vue&type=template&id=7140428b&scoped=true&"
import script from "./SimpleTree.vue?vue&type=script&lang=js&"
export * from "./SimpleTree.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTree.vue?vue&type=style&index=0&id=7140428b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140428b",
  null
  
)

component.options.__file = "SimpleTree.vue"
export default component.exports